export const serializeDate = (date: Date): string => date.toISOString();
